import { SkinnableComponent, ComponentSkinProps } from '../../../types/component-skin';
import { COMPONENT_TYPES } from '../../../constants';
import { useFAQLogic } from './FAQLogic';
import BasicFAQSkin from './skins/BasicFAQSkin';

/**
 * FAQ 컴포넌트의 스킨 시스템 정의
 */
export const FAQSkinnable: SkinnableComponent = {
  type: COMPONENT_TYPES.FAQ,
  name: '자주 묻는 질문',
  category: 'content',
  icon: '❓',
  options: [
    {
      type: 'text',
      label: '제목',
      key: 'title',
      default: '자주 묻는 질문'
    },
    {
      type: 'color',
      label: '제목 색상',
      key: 'titleColor',
      default: '#333333'
    },
    {
      type: 'text',
      label: '제목 크기',
      key: 'titleSize',
      default: '24px'
    },
    {
      type: 'color',
      label: '질문 배경색',
      key: 'questionBgColor',
      default: '#f8f8f8'
    },
    {
      type: 'color',
      label: '질문 텍스트 색상',
      key: 'questionTextColor',
      default: '#333333'
    },
    {
      type: 'color',
      label: '답변 배경색',
      key: 'answerBgColor',
      default: '#ffffff'
    },
    {
      type: 'color',
      label: '답변 텍스트 색상',
      key: 'answerTextColor',
      default: '#555555'
    },
    {
      type: 'color',
      label: '테두리 색상',
      key: 'borderColor',
      default: '#e0e0e0'
    },
    {
      type: 'number',
      label: '테두리 둥글기',
      key: 'borderRadius',
      default: 8,
      min: 0,
      max: 20
    }
  ],
  defaultSkin: 'basic',
  internalSkins: {
    basic: BasicFAQSkin as any
  },
  useLogic: useFAQLogic as any,
  defaultProps: {
    title: '자주 묻는 질문',
    faqItems: [
      {
        question: '서비스 이용 방법은 어떻게 되나요?',
        answer: '회원가입 후 로그인하시면 모든 서비스를 이용하실 수 있습니다. 각 메뉴별로 자세한 안내가 제공되고 있으니 참고해주세요.'
      },
      {
        question: '결제 수단은 무엇을 지원하나요?',
        answer: '신용카드, 체크카드, 계좌이체, 간편결제 등 다양한 결제 수단을 지원하고 있습니다.'
      },
      {
        question: '환불 정책은 어떻게 되나요?',
        answer: '구매 후 7일 이내 환불 요청이 가능하며, 상품의 하자가 있는 경우 30일 이내 교환 또는 환불이 가능합니다.'
      },
      {
        question: '배송은 얼마나 걸리나요?',
        answer: '일반적으로 주문 후 2-3일 이내 배송이 완료됩니다. 지역에 따라 차이가 있을 수 있습니다.'
      }
    ],
    titleStyle: {
      fontSize: '24px',
      fontWeight: 'bold',
      marginBottom: '20px',
      textAlign: 'left',
      color: '#333'
    },
    style: {
      width: '100%',
      fontFamily: 'Arial, sans-serif'
    }
  }
};